module.exports = __webpack_public_path__ + "static/media/1.c00c3871.jpg";